// Unpublished Work © 2026 Deere & Company.

import t from 'tcomb';

export const DigitalUserAccountPhone = t.struct({
    countryCode: t.maybe(t.String),
    phoneNumber: t.maybe(t.String),
    formattedPhone: t.maybe(t.String),
    verified: t.maybe(t.Boolean)
}, {
    defaultProps: {
        countryCode: '',
        phoneNumber: '',
        formattedPhone: '',
        verified: false
    },
    name: 'DigitalUserAccountPhone',
    strict: true
});
